import BurgerMenu from '../plugins/BurgerMenuPlugin';

export default function initBurgerMenu() {
  const burgerMenuSelector = document.querySelector('.menu-opener');
  // function takes 1 argument - breakpoint (default value is '1024px')
  // to set custom breakpoint call it like new BurgerMenu('768px'); It activates menu from 0 to 767ox screens width
  if (burgerMenuSelector) {
    new BurgerMenu('1280px');
  }
}
